import { useNavigate } from 'react-router-dom';
import './Dashboard.css'; // new css file

const Dashboard = ({ isAllowed = false }) => {
  const navigate = useNavigate();

  const restrictedTitle = isAllowed
    ? undefined
    : 'You do not have permission to access this';

  return (
    <div className="dashboard">
      <h1 className="dashboard-title">
        Customer Credit <br /> Applications
      </h1>

      <div className="dashboard-buttons">
        <button
          className="dash-btn request-btn"
          onClick={() => navigate('internal')}
        >
          REQUEST Application
        </button>
        <button
          className="dash-btn process-btn"
          onClick={() => navigate('process')}
          disabled={!isAllowed}
          title={restrictedTitle}
        >
          PROCESS Application
        </button>
        <button
          className="dash-btn reject-btn"
          onClick={() => navigate('reject')}
          disabled={!isAllowed}
          title={restrictedTitle}
        >
          REJECT Application
        </button>
      </div>

      <div className="copy-button-wrapper">
        <button
          onClick={() => navigate('copy')}
          className="copy-button"
          disabled={!isAllowed}
          title={restrictedTitle}
          aria-label="Copy customer"
        />
      </div>
    </div>
  );
};

export default Dashboard;
